import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet"; 

var selectStates = [false, false, false, false, false, false, false, false];

function Legend({ mapRef, euiStates, setEUIStates, loopStates, setLoopStates, setIsExcellentEUI, setSelectedQuality, boolyRef }) {
    // used to get the map reference (Legend component is the child and Map component is its parent)
    const map = useMap();

    // used to display the legend every time the map updates
    useEffect(() => {
        // do nothing if it doesn't have a map reference
        if (!map)   return;

        // gets all elements containing legend-container class
        const existingLegend = document.querySelector(".legend-container");
        // removes ONE instance of the element containing the legend-container class
        if (existingLegend) existingLegend.remove();

        // gets all elements containing legend-container class
        const existingLegend2 = document.querySelector(".legend-container2");
        // removes ONE instance of the element containing the legend-container class
        if (existingLegend2) existingLegend2.remove();

        // creates the legend instance and position it top-right on the map
        const legend = L.control({ position: "topright" });
        const legend2 = L.control({ position: "bottomleft" }); // topleft, bottomleft, or topright?

        // when the legend is added to the map, create a div that contains the symbols and texts
        legend.onAdd = () => {
            // creates the legend element
            const div = L.DomUtil.create("div", "legend-container");
            // define the contents of the legend
            div.innerHTML = `
                <h6><b>EUI Quality</b></h6>
                <div class="legend-body">
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(0, 255, 0)"></span><span >Excellent EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(155, 255, 100)"></span><span >Good EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(255, 255, 0)"></span><span >Average EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(255, 155, 0)"></span><span >Poor EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(255, 0, 0)"></span><span >Very Poor EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(200, 0, 0)"></span><span >Extremely Poor EUI</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: rgb(0, 0, 0)"></span><span >No Meter Data</span></div>
                    <div class="toggable-content"><span class="legend-symbol" style="background-color: #806A5C"></span><span >No EUI</span></div>
                </div>
            `;

            // toggable selections but can only select one at a time
            const items = div.querySelectorAll('.legend-body > div');
            const contents = div.querySelectorAll('.toggable-content');

            items.forEach((item, index) => {
                item.addEventListener('click', () => {
                    const isActive = contents[index].classList.contains('legend-selected');

                    // 👇 Clear loop legend DOM styles
                    document.querySelectorAll('.legend-container2 .legend-selected')
                        .forEach(el => el.classList.remove('legend-selected'));
                    // and set boolean states to false
                    loopStates.forEach((_, i) => setLoopStates[i](false));

                    // 👇 Clear EUI states
                    contents.forEach((content, i) => {
                        content.classList.remove('legend-selected');
                        setEUIStates[i](false);
                    });

                    // if (euiStates.every(es => es === false)) {
                    //     contents.forEach(content => {
                    //         content.classList.remove('legend-selected');
                    //     })
                    // }

                    // Toggle the clicked one back on only if it wasn't active already
                    if (!isActive) {
                        // setLoopStates[0](false);
                        // setLoopStates[1](false);
                        // setLoopStates[2](false);
                        // setLoopStates[3](false);
                        // setLoopStates[4](false);

                        contents[index].classList.add('legend-selected');
                        setEUIStates[index](true);
                        boolyRef.current = true;
                    }
                });
            });

            // legend created
            return div;
        };

        legend2.onAdd = () => {
            const div = L.DomUtil.create("div", "legend-container2");

            div.innerHTML = `
                <h6><b>Cooling Loops</b></h6>
                <div class="legend-body2">
                    <div class="toggable-content"><span class="dashed-symbol" style="border-color: #3023bf"></span><span >A</span></div>
                    <div class="toggable-content"><span class="dashed-symbol" style="border-color: #c093e9"></span><span >B</span></div>
                    <div class="toggable-content"><span class="dashed-symbol" style="border-color: #9f2047"></span><span >C</span></div>
                    <div class="toggable-content"><span class="dashed-symbol" style="border-color: #d1711e"></span><span >D</span></div>
                    <div class="toggable-content"><span class="dashed-symbol" style="border-color: #2bbbb7"></span><span >QUAD</span></div>
                </div>
            `

            // Cooling Loop A: rgb(255, 0, 255)
            // Cooling Loop B: rgb(0, 0, 255)
            // Cooling Loop C: rgb(0, 155, 255)
            // Cooling Loop D: rgb(0, 150, 200)
            // Cooling Loop QUAD: rgb(155, 0, 255)

            // toggable selections but can only select one at a time
            const items = div.querySelectorAll('.legend-body2 > div');
            const contents = div.querySelectorAll('.toggable-content');

            items.forEach((item, index) => {
                item.addEventListener('click', () => {
                    const isActive = contents[index].classList.contains('legend-selected');

                    // 👇 Clear EUI legend DOM styles
                    document.querySelectorAll('.legend-container .legend-selected')
                        .forEach(el => el.classList.remove('legend-selected'));
                    euiStates.forEach((_, i) => setEUIStates[i](false));

                    // 👇 Clear loop states
                    contents.forEach((content, i) => {
                        content.classList.remove('legend-selected');
                        setLoopStates[i](false);
                    });

                    // if (loopStates.every(ls => ls === false)) {
                    //     console.log("uyo");
                    //     contents.forEach(content => {
                    //         content.classList.remove('legend-selected');
                    //     });
                    // }

                    // Toggle the clicked one back on only if it wasn't active already
                    if (!isActive) {
                        // setEUIStates[0](false);
                        // setEUIStates[1](false);
                        // setEUIStates[2](false);
                        // setEUIStates[3](false);
                        // setEUIStates[4](false);
                        // setEUIStates[5](false);
                        // setEUIStates[6](false);
                        // setEUIStates[7](false);
                        

                        contents[index].classList.add('legend-selected');
                        setLoopStates[index](true);
                        // console.log("legend selected", loopStates[4]);
                        boolyRef.current = true;
                    }
                });
            });

            return div;
        };
        
        // used to place the legend on the map
        legend.addTo(map);
        legend2.addTo(map);
    }, [map]);
    

    // function testy() {
    //     setEUIStates[0](true);
    // }

    return null;
}

function toggleSelect(el, index) {
    // if (!theSelectStates[index]) {
    //     el.style.backgroundColor = "rgb(240, 240, 240)";
    // } else {
    // JS styling overrides CSS styling, which explains why the CSS hover effect was disabled 
    //     el.style.backgroundColor = "white";
    // }
    // theSelectStates[index] = !theSelectStates[index];
    // el is element, classList is the list of all classes the element has, and toggle enables/disables the specified class in the classList
    el.classList.toggle("legend-selected");


}

export default Legend;